export default __webpack_public_path__ + "static/media/1107.db65eea9.png";